<app-help-cta
  [originPage]="'Billing'"
  [hasInvoice]="selectedInvoice ? true : false"
></app-help-cta>

<div
  class="bg-white shadow-[-2px_5px_15px_rgba(0,0,0,0.1)] transition-all duration-300 ease-in-out w-[calc(50vw-15px)] h-screen rounded-tl-2xl pl-4 pt-4 relative overflow-hidden"
>
  @if (isInvoicesLoading || pdfLoading) {
    <div class="flex items-center justify-center h-full w-full">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else {
    @if (selectedInvoice) {
      <div class="border-b border-gray-500 pb-4 mb-4">
        <h1 class="text-3xl font-light mb-2">Invoice:</h1>

        <div class="flex items-center justify-between">
          <h2 class="text-base font-normal">
            Posted on
            {{
              selectedInvoice.ContentDocument.Title.slice(0, 10)
                | date: 'longDate'
            }}
          </h2>
          <button
            class="rounded-full h-9 w-9 flex items-center justify-center mr-5 hover:bg-blue-100 focus:outline-none transition-colors duration-200"
            (click)="onDownload(selectedInvoice)"
          >
            <mat-icon svgIcon="pdf-file" class="text-blue-500"></mat-icon>
          </button>
        </div>
      </div>

      <div
        class="w-full h-[calc(100vh-322px)] mt-0 pt-2.5 overflow-hidden relative"
      >
        @if (pdfUrl && canEmbedPdf) {
          <div class="w-full h-full overflow-auto">
            <pdf-viewer
              [src]="pdfUrl"
              [(page)]="page"
              [show-all]="true"
              [show-borders]="false"
              [original-size]="false"
              [autoresize]="true"
              [render-text]="true"
              (error)="onError()"
              (after-load-complete)="afterLoadComplete($event)"
              class="w-full h-full block"
            ></pdf-viewer>
          </div>
        }

        @if (pdfLoading) {
          <div class="flex items-center justify-center h-full w-full">
            <mat-spinner [diameter]="40"></mat-spinner>
          </div>
        }
      </div>

      @if (!canEmbedPdf && !pdfLoading) {
        <div class="text-center text-gray-600 p-4 mt-6">
          You don't have a PDF plugin, but you can
          <button
            class="underline hover:text-blue-800 transition-colors bg-transparent border-none text-blue-600 cursor-pointer text-base p-0"
            (click)="onDownload(selectedInvoice)"
          >
            download the PDF
          </button>
        </div>
      }
    } @else {
      <div class="w-[calc(50vw-15px)] h-screen rounded-l-2xl pl-4 pt-4">
        <div class="border-b border-gray-500 pb-6 mb-6">
          <h1 class="text-3xl font-light mb-2">Invoice:</h1>
          <h2 class="text-base font-normal">- - -</h2>
        </div>
        @if (!isInvoicesLoading) {
          <p class="text-center py-6">
            No invoices have posted to this account yet.
          </p>
        }
      </div>
    }
  }
</div>
